var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMandatoryPayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    rx: 2,
    fill: "#7C69B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70605 3.16797L4.07568 7.03516L5.43799 3.16797H6.88086V8.5H5.77856V7.04248L5.88843 4.52661L4.44922 8.5H3.69482L2.25928 4.53027L2.36914 7.04248V8.5H1.27051V3.16797H2.70605ZM8.93896 6.62134V8.5H7.84033V3.16797H9.92041C10.3208 3.16797 10.6724 3.24121 10.9751 3.3877C11.2803 3.53418 11.5146 3.74292 11.6782 4.01392C11.8418 4.28247 11.9236 4.58887 11.9236 4.93311C11.9236 5.45557 11.7441 5.86816 11.3853 6.1709C11.0288 6.47119 10.5344 6.62134 9.9021 6.62134H8.93896ZM8.93896 5.73145H9.92041C10.2109 5.73145 10.4319 5.66309 10.5833 5.52637C10.7371 5.38965 10.814 5.19434 10.814 4.94043C10.814 4.6792 10.7371 4.46802 10.5833 4.30688C10.4294 4.14575 10.217 4.06274 9.94604 4.05786H8.93896V5.73145Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryPayout);
export default __webpack_public_path__ + "static/media/mandatory-payout.190bc53f1014cfd835a092e55e5fe040.svg";
export { ForwardRef as ReactComponent };